// 获取题目序号
export function getSerialNumber(serialNumberType, index, prefix, suffix) {
    if (serialNumberType == 'none' || index < 1) {
        return "";
    }
    var num = '';
    if (!serialNumberType || serialNumberType == 'number') {
        num = index;
    } else if (serialNumberType == 'letter') {
        num = getLetterSerial(index);
    }
    return (prefix ? prefix : '') + num + (suffix ? suffix : '');
}

// 数组序号转字母序号
function getLetterSerial(index) {
    var charcode;
    if (index % 26 == 0) {
        //
        var n = index / 26;
        if (n == 1) {
            return "Z";
        } else {
            return getLetterSerial(n - 1) + "Z";
        }
    }
    return index
        .toString(26)
        .split("")
        .map(function (item) {
            charcode = item.charCodeAt(0);
            charcode += charcode >= 97 ? 9 : 48;
            return String.fromCharCode(charcode);
        })
        .join("")
        .toUpperCase();
}